import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"

// TODO: Deprecate this component

export function LegacySeo({
  canonical = false,
  lang,
  meta,
  image = null,
  title,
  description,
  defaultTitle,
  location,
  site,
}) {
  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={defaultTitle ? `%s | ${defaultTitle}` : null}
      link={[
        {
          rel: "canonical",
          key: canonical
            ? `https://www.klipfolio.com${canonical}`
            : location.buildHref,
          href: canonical
            ? `https://www.klipfolio.com${canonical}`
            : location.buildHref,
        },
      ]}
      meta={[
        {
          name: `description`,
          content: description,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: description,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        ...(image
          ? [
              {
                property: "og:image",
                content: `${image}`,
              },
              {
                name: `twitter:image`,
                content: `${image}`,
              },
            ]
          : []),
        ...(canonical
          ? [
              {
                property: "og:url",
                content: `https://www.klipfolio.com${canonical}`,
              },
              {
                name: `twitter:url`,
                content: `https://www.klipfolio.com${canonical}`,
              },
            ]
          : []),
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata?.author || ``,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: description,
        },
      ].concat(meta)}
    />
  )
}

LegacySeo.propTypes = {
  canonical: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  image: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  defaultTitle: PropTypes.string.isRequired,
  location: PropTypes.object.isRequired,
  site: PropTypes.object.isRequired,
}
